var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgM4A = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2278 12.8154V11.5138L19.155 7.5H20.821V11.4605H21.5923V12.8091H20.821V13.9872H19.253V12.8091L16.2278 12.8154ZM19.3808 9.30022L17.8043 11.4669H19.3808V9.30022Z",
    fill: "#00C650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.203 13.9936V7.63424L13.3282 7.64064L11.6239 12.0698L9.89399 7.64064H8V14H9.54883V10.014L10.9358 14H12.2758L13.6542 10.0225V13.9936H15.203Z",
    fill: "#00C650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0504 12.824H24.6473L24.2489 13.9936H22.6191L24.9626 7.63211H26.7479L29.0914 13.9936H27.4424L27.0504 12.824ZM26.6499 11.6459L25.8531 9.29173L25.0478 11.6459H26.6499Z",
    fill: "#00C650"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 2.5C1.87589 2.5 0 4.37174 0 6.70259V15.2974C0 17.6283 1.87589 19.5 4.16833 19.5H32.8317C35.1241 19.5 37 17.6283 37 15.2974V6.70259C37 4.37174 35.1241 2.5 32.8317 2.5H4.16833ZM0.973684 6.70259C0.973684 4.94367 2.39431 3.5 4.16833 3.5H32.8317C34.6057 3.5 36.0263 4.94368 36.0263 6.70259V15.2974C36.0263 17.0563 34.6057 18.5 32.8317 18.5H4.16833C2.39431 18.5 0.973684 17.0563 0.973684 15.2974V6.70259Z",
    fill: "#00C650"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgM4A);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/m4a.193e6759783003005f3ddbb2f1f8cf05.svg";